module.exports = __webpack_public_path__ + "static/img/Group 232.d97b3448.svg";